import {
  Box,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import * as React from "react";
import StudentFormNoSend from "../../views/Students/StudentFormNoSend";
import CourseSelectFormNoSend from "../Course/CourseSelectFormNoSend";
import PaymentSudentDataPrivate from "./PaymentStudentDataPrivate";
import {
  CourseType,
  PaymentsType,
  RepresentativeType,
  StudentFormType,
} from "../../types/entitiesModel";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import {
  fetchRepresentativeByUserEmail,
  getAllUserData,
} from "../../utils/Utils";


const CreateClientStudent: React.FC = () => {
  const { token } = React.useContext(AuthContext) || {};
  const navigate = useNavigate();

  const [representativeEmail, setRepresentativeEmail] =
    React.useState<string>("");
  const [representative, setRepresentative] =
    React.useState<RepresentativeType | null>(null);
  const [formStateStudent, setFormStateStudent] =
    React.useState<StudentFormType>({
      name: "",
      document: "",
      email: "",
      phone: "",
      address: "",
      representative_id: 0,
      category_id: 0,
      imageString: ""
    });

  const [reference, setReference] = React.useState<string>("");
  const [selectionCourse, setSelectionCourse] =
    React.useState<CourseType | null>(null);
  const [selectionPaymentMethod, setSelectionPaymentMethod] =
    React.useState<PaymentsType | null>(null);
  const [repExists, setRepExists] = React.useState<boolean>(false);
  const [step, setStep] = React.useState<number>(1);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleChangeFormStudent = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setFormStateStudent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleNextStep = () => {
    setError(null);
    if (step < 2) {
      setStep(step + 1);
    } else {
      handleSubmit();
    }
  };

  const handlePreviousStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  React.useEffect(() => {
    setLoading(true);

    if (token) {
      let userData = getAllUserData(token);

      console.log("user data: " + JSON.stringify(userData));

      if (userData?.email !== null && userData?.email !== undefined) {
        setRepresentativeEmail(userData?.email);
      }
    }

    setLoading(false);
  }, [token]);

  React.useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      setLoading(true);
      setError(null); // Resetea el error antes de una nueva solicitud

      if (representativeEmail !== "" && token) {
        const data = await fetchRepresentativeByUserEmail(representativeEmail, token);

        if (typeof data === "string") {
          setError(data);
        } else {
          setRepresentative(data);
        }
      }

      setLoading(false);
    };

    fetchData();

    setLoading(false);
  }, [representativeEmail, token]);

  // React.useEffect(() => {
  //   console.log("Data del representante: " + JSON.stringify(representative));
  // }, [representative]);

  /**
   * to send data to api
   */
  const handleSubmit = async () => {
    if (
      !formStateStudent.name ||
      !selectionCourse ||
      !selectionPaymentMethod ||
      !reference
    ) {
      setError(
        "Por favor, complete todos los campos y asegúrese de que las contraseñas coincidan."
      );
      return;
    }

    const data = {
      student: formStateStudent,
      representative: representative,
      course: selectionCourse,
      paymentMethod: selectionPaymentMethod,
      reference,
    };

    setLoading(true);
    setError(null);

    try {
      const response = await fetch("appservice/coursestudentsprivate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || "Hubo un problema al enviar el formulario."
        );
      }

      alert("Inscripción completada con éxito");
      setTimeout(() => {
        navigate("/admin");
      }, 1000);
    } catch (err: any) {
      setError(err.message || "Ocurrió un error en el servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {step === 1 && (
        <>
          <Box sx={{ paddingLeft: 2, mb: 2 }}>
            <Typography variant="h1">Información de inscripción</Typography>
          </Box>
          <Box>
            <CourseSelectFormNoSend
              selectionCourse={selectionCourse}
              setSelectionCourse={setSelectionCourse}
            />
          </Box>
          <Box>
            <StudentFormNoSend
              formState={formStateStudent}
              handleChangeForm={handleChangeFormStudent}
              setFormStateStudent={setFormStateStudent}
              repExists={repExists}
              setRepExists={setRepExists}
              showRepresentative={false}
            />
          </Box>
        </>
      )}

      {step === 2 && (
        <>
          <Box>
            <Typography variant="h1" sx={{ ml: 2, mb: 4 }}>
              Información de Pago
            </Typography>
            <PaymentSudentDataPrivate
              selectionPaymentMethod={selectionPaymentMethod}
              setSelectionPaymentMethod={setSelectionPaymentMethod}
              courseData={selectionCourse}
              representativeData={representative}
              studentData={formStateStudent}
              reference={reference}
              setReference={setReference}
            />
          </Box>
        </>
      )}

      {/* Botones de navegación */}
      <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
        <Button
          variant="outlined"
          onClick={handlePreviousStep}
          disabled={step === 1}
        >
          Anterior
        </Button>
        <Button variant="contained" onClick={handleNextStep} disabled={loading}>
          {step === 1 ? (
            "Siguiente"
          ) : loading ? (
            <CircularProgress size={24} />
          ) : (
            "Confirmar"
          )}
        </Button>
      </Box>

      {/* Muestra de error */}
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default CreateClientStudent;
